module.exports = __webpack_public_path__ + "img/logo.86fdfc74.png";